import { Component, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { CreateComponent } from '@app/common/templates/create/create.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TblTourGruppeCreateComponent } from '../../tbl_tour_gruppe/create/create.component';
import { TblTourTypCreateComponent } from '../../tbl_tour_typ/create/create.component';

@Component({
	templateUrl: '../../../../common/templates/create/create.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/create/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblTourCreateComponent extends CreateComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		@Optional() public config: DynamicDialogConfig,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		@Optional() public ref: DynamicDialogRef,
		public router: Router,
		public translate: TranslateService,
	) {
		super(accountService, breadcrumbService, config, confirmationService, crudService, dialogService, globals, messageService, ref, router, translate);

		this.apiUrl = 'TblTour';
		this.name = 'MENU.TOUR';
		this.url = '/' + PATH.TOUR;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: false, width: 400 },
				{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400 },
				{ type: 'object', key: 'typ_id', required: false, width: 400, apiUrl: 'TblTourTyp', createComponent: TblTourTypCreateComponent },
				{ type: 'list', key: 'FREMD_gruppe_ids', required: false, width: 400, apiUrl: 'TblTourGruppe', createComponent: TblTourGruppeCreateComponent },
				{ type: 'text', key: 'fraktion_hint_ankey', required: false, width: 400 },
				{ type: 'numeric', key: 'ident_check_connection', required: false, width: 400 },
				{ type: 'text', key: 'tourkennung', required: false, width: 400 },
				{ type: 'text', key: 'gebietskennung', required: false, width: 400 },
				{ type: 'boolean', key: 'feiertagstour', required: false, width: 400 },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.CREATE', routerLink: [this.url + '/' + PATH.CREATE] }
		]);
	}
}
